const attribution = require('./utils/attribution');

module.exports = ({
  id: 'Employer',
  question: 'Who was the perk provider?',
  type: 'input',
  attribution: attribution.BizDev,
});
